import React, {useCallback, useContext} from 'react'
import {debounce} from "lodash";
import useCurrentConcept from "../hooks/useCurrentConcept";
import {ContentContext} from "../common/ContentContext";
import {UserContext} from "../common/UserContext";
import {useScreenMode} from "../common/context/ScreenModeContext";

const LessonTitleControls = () => {
    const { content } = useContext(ContentContext);
    const { loadPreviousConcept, loadNextConcept } = useCurrentConcept();
    const { user } = useContext(UserContext);
    const {mobileScreenMode} = useScreenMode();

    const handleLoadPreviousConcept = () => {
        loadPreviousConcept(localStorage.getItem("conceptId"));
    };

    const debouncedHandleLoadPreviousConcept =  useCallback(debounce(handleLoadPreviousConcept, 1000, { 'leading': true }), [user.cmsMode]);

    const handleLoadNextConcept = () => {
        loadNextConcept(localStorage.getItem("conceptId"));
    };

    const debouncedHandleLoadNextConcept =  useCallback(debounce(handleLoadNextConcept, 1000, { 'leading': true }), [user.cmsMode]);

    return(
        <>
            <a
                tabIndex={0}
                aria-label="Previous lesson"
                style={{paddingTop: '4px'}}
                className={
                    'material-font margin-r--s ch-lesson-nav-button' +
                    (content.currentConcept?.previousConceptId == undefined ? ' disabled' : '')
                }
                onClick={debouncedHandleLoadPreviousConcept}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        debouncedHandleLoadPreviousConcept();
                    }
                }}
            >
                navigate_before
            </a>
            <div className={'ch-page-header-title-concept'}>
                <h1 className={'ch-page-header-lesson-title'}>
                    <span className="ch-mathjax"
                          dangerouslySetInnerHTML={{__html: content.currentConcept ? content.currentConcept.conceptName : ''}}/>
                </h1>
                {(user.showResourceIds && content.currentConcept != undefined && !mobileScreenMode) && (
                    <div className={'ch-concept-info'}>
                        <div>Lesson: #{content.currentConcept.conceptId}</div>
                        <div>Lesson group: #{content.currentConcept.conceptGroupId}</div>
                    </div>
                )}
            </div>
            <a
                tabIndex={0}
                aria-label="Next lesson"
                style={{ paddingTop: '4px' }}
                className={
                    'material-font margin-l--s ch-lesson-nav-button' +
                    (content.currentConcept?.nextConceptId == undefined ? ' disabled' : '')
                }
                onClick={debouncedHandleLoadNextConcept}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        debouncedHandleLoadNextConcept();
                    }
                }}
            >
                navigate_next
            </a>
        </>
    )
}

export default LessonTitleControls;